const linkGroups = [
  {
    title: "内容分区",
    links: [
      { label: "今日瓜田", href: "#today" },
      { label: "实时热瓜榜", href: "#rank" },
      { label: "翻车档案", href: "#persons" },
      { label: "来龙去脉", href: "#timeline" },
      { label: "实锤图鉴", href: "#gallery" },
    ],
  },
  {
    title: "围观指南",
    links: [
      { label: "网友现场", href: "#comments" },
      { label: "热议词条", href: "#rank" },
      { label: "瓜友投票", href: "#comments" },
      { label: "吃瓜教程", href: "#timeline" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "栏目介绍", href: "#today" },
      { label: "投稿递瓜", href: "#comments" },
      { label: "理性吃瓜声明", href: "#comments" },
      { label: "联系方式", href: "#comments" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-[rgb(var(--ink))]/10 bg-[rgb(var(--paper-deep))]">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[rgb(var(--brand))] text-[rgb(var(--paper))]">
                <i className="ri-slice-fill h-5 w-5 flex items-center justify-center"></i>
              </span>
              <span className="font-display text-[20px] font-black tracking-wide">吃瓜黑料</span>
            </a>
            <p className="mt-3 text-[13px] leading-relaxed text-[rgb(var(--ink-soft))]">
              明星黑料、网红黑历史与主播翻车现场，按人物归类，随时来瓜田蹲一个新瓜。
            </p>
            <p className="mt-3 flex items-center gap-2 text-[12px] text-[rgb(var(--ink-soft))]/80">
              <span className="h-1.5 w-1.5 animate-live rounded-full bg-[rgb(var(--brand))]"></span>
              编辑部实时在线 · 每小时都有新料
            </p>
          </div>

          {linkGroups.map((g) => (
            <div key={g.title}>
              <h4 className="font-display mb-3 text-[14px] font-bold">{g.title}</h4>
              <ul className="flex flex-col gap-2">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="whitespace-nowrap text-[13px] text-[rgb(var(--ink-soft))] transition-colors hover:text-[rgb(var(--brand))]"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col justify-between gap-3 rounded-lg border border-[rgb(var(--ink))]/10 bg-white/60 p-4 sm:flex-row sm:items-center">
          <p className="flex items-start gap-2 text-[12px] leading-relaxed text-[rgb(var(--ink-soft))]">
            <i className="ri-alert-line mt-0.5 h-4 w-4 shrink-0 flex items-center justify-center text-[rgb(var(--brand))]"></i>
            本站内容仅为娱乐向事件复盘与素材整理，全部来自公开流传渠道，不代表任何事实结论。请理性吃瓜，不信谣不传谣，以官方核实为准。
          </p>
          <span className="flex shrink-0 items-center gap-2 whitespace-nowrap text-[12px] text-[rgb(var(--ink-soft))]">
            <i className="ri-shield-check-line h-4 w-4 flex items-center justify-center text-[rgb(126,158,106)]"></i>
            友善围观 · 拒绝网暴
          </span>
        </div>
      </div>

      <div className="border-t border-[rgb(var(--ink))]/8 bg-[rgb(var(--ink))] text-[rgb(var(--paper))]">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between gap-2 px-4 py-4 text-[12px] text-[rgb(var(--paper))]/60 sm:flex-row md:px-6">
          <p>© 2026 吃瓜黑料 · 看谁又翻车 | 本页为内容展示页</p>
          <p className="flex items-center gap-3">
            <a href="#top" className="flex items-center gap-1 whitespace-nowrap transition-colors hover:text-[rgb(244,146,36)]">
              <i className="ri-arrow-up-line h-3.5 w-3.5 flex items-center justify-center"></i>
              回到瓜田顶部
            </a>
            <span className="hidden sm:inline">·</span>
            <a href="#rank" className="whitespace-nowrap transition-colors hover:text-[rgb(244,146,36)]">
              实时热瓜榜
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}